import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text } from 'wix-style-react';
import { withInjectedRootStore, RootStore } from 'providers';
import { SaleBannerSubtitle } from './SaleBannerSubtitle';
import s from './SaleBanner.scss';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { useSaleBannerTitle } from './useSaleBannerTitle';

interface SaleBannerContentProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const SaleBannerContentComp: React.FunctionComponent<SaleBannerContentProps> = ({
  rootStore,
  experiments,
}) => {
  const { discountPercent } = rootStore.appStore.appContext.saleParams;
  const bannerTitle = useSaleBannerTitle(rootStore.appStore, experiments);

  return (
    <div className={s.saleText}>
      <Text className={s.saleSubtitle} weight='normal' size='small'>
        <SaleBannerSubtitle />
      </Text>
      <Text className={s.saleTitle} weight='bold' size='small'>
        <Trans
          i18nKey={bannerTitle}
          values={{ percent: discountPercent || '50' }}
        >
          <span className={s.saleDiscount}>
            SAVE {{ percent: discountPercent || '50' }}%
          </span>
          rest
        </Trans>
      </Text>
    </div>
  );
};

export const SaleBannerContent = withInjectedRootStore(
  withExperiments(SaleBannerContentComp),
);
